function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun-sketch-2392950");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-sketch-2392950",
  transform: "translate(0.520000, 0.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M331.52,112.0008 L421.68,112.0008 C420.0003,109.1992 417.7581,106.3984 414.9612,103.6016 L325.9222,14.5586 C323.6839,12.3203 320.8831,10.0781 317.523798,7.8398 L317.523798,97.4418 C317.519893,105.8402 323.68,112.0008 331.5198,112.0008 L331.52,112.0008 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "128.24 315.28 192.638 400.397 165.759 315.28"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "226.24 258.72 202.717 258.72 188.717 294.56 240.24 294.56"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "187.6 315.28 214.479 400.96 241.358 315.28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.88,258.72 L151.759,258.72 C149.5207,258.72 147.2785,259.8411 146.1574,262.0794 L126.5554,294.5594 L166.8754,294.5594 L180.88,258.72 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331.52,149.52 C302.961,149.52 280,126.559 280,98 L280,0 L49.84,0 C36.399,0 24.078,5.0391 14.559,14.559 C5.0395,24.0785 -2.84217094e-14,36.399 -2.84217094e-14,49.84 L-2.84217094e-14,481.6 C-2.84217094e-14,509.041 22.398,531.44 49.84,531.44 L379.68,531.44 C407.121,531.44 429.52,509.042 429.52,481.6 L429.52,149.52 L331.52,149.52 Z M322.5591,320.32 L235.7621,434.56 C230.7191,441.2827 222.8791,445.201 214.4811,445.201 C206.0831,445.201 198.2431,441.2791 193.2001,434.56 L106.4031,320.32 C99.6843,311.3591 99.1219,299.601 104.7234,290.082 L128.2434,251.441 C133.2825,243.6012 142.2434,238.562 151.2044,238.562 L277.2044,238.562 C286.7239,238.562 295.6844,243.6011 300.1654,251.441 L323.6854,290.082 C329.8416,299.6015 329.2831,311.359 322.5604,320.32 L322.5591,320.32 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.2,258.72 L248.083,258.72 L262.083,294.56 L302.403,294.56 L282.801,262.08 C281.6799,259.8417 279.4416,258.7206 277.1994,258.7206 L277.2,258.72 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "236.32 400.4 300.718 315.283 263.198 315.283"
})));

var SvgSketch = function SvgSketch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "431px",
    height: "532px",
    viewBox: "0 0 431 532",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSketch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sketch.b9da663c.svg";
export { ForwardRef as ReactComponent };